import React from 'react';
import {ScrollView, View} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';

import PeopleListItem from '../PeopleListItem';

import {styles} from './PeopleListItem.style';

const peopleList = [
  {
    firstName: 'Testing1',
    lastName: 'Test',
    accountEmail: '123@testing.com',
    avatarUrl: null,
  },
  {
    firstName: 'Testing2',
    lastName: 'Test',
    accountEmail: '1234@testing.com',
    avatarUrl: null,
  },
  {
    firstName: 'Testing3',
    lastName: 'Test',
    accountEmail: '1235@testing.com',
    avatarUrl: null,
  },
];

storiesOf('base', module).add('PeopleListItem', () => (
  <ScrollView>
    <FlexView>
      <Spacing size={20}>
        <Heading level={1}>People List Item Component</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>{'PeopleListItem'}</Code> component is based off the{' '}
          <Code>{'ListItem'}</Code> component displaying a bonus or rank
          qualification with user avatars.
        </Text>
        <Spacer size={16} />
        <Text>
          The <Code>{'currentCount'}</Code> and <Code>{'targetCount'}</Code>{' '}
          props will display the progress and determine the length of the avatar
          list.
        </Text>
        <Spacer size={16} />
        <Text>
          The <Code>{'PeopleListItem'}</Code> accepts an array of people
          objects, <Code>{'avatarUrls'}</Code>, and will display a user's avatar
          or randomly generated avatar from their email. Numbered placeholders
          will be shown for unfilled positions.
        </Text>
      </Spacing>
    </FlexView>
    <Spacer size={10} />
    <View style={styles.wrapper}>
      <Gutter>
        <PeopleListItem
          hasCheckbox
          peopleList={peopleList}
          currentCount={3}
          label="Executive Director Teams"
          targetCount={5}
        />
      </Gutter>
    </View>
    <Spacing size={20}>
      <Heading level={1}>Expanded View</Heading>
      <Spacer size={16} />
      <Text>
        An <Code>{'onPress'}</Code> is passed to the{' '}
        <Code>{'PeopleListItem'}</Code> and <Code>{'canExpand'}</Code> controls
        whether or not the list item can be expanded. The{' '}
        <Code>{'expanded'}</Code> prop controls the state of the caret. By
        default, both props are set to <Code>{'true'}</Code>.
      </Text>
    </Spacing>
    <View style={styles.wrapper}>
      <Gutter>
        <PeopleListItem
          hasCheckbox
          peopleList={peopleList}
          currentCount={3}
          expanded={false}
          label="Executive Director Teams"
          readonly
          targetCount={5}
        />
      </Gutter>
    </View>
    <Spacing size={20}>
      <FlexView>
        <Code>{'expanded={false}'}</Code>
      </FlexView>
    </Spacing>
    <View style={styles.wrapper}>
      <Gutter>
        <PeopleListItem
          hasCheckbox
          canExpand={false}
          peopleList={peopleList}
          currentCount={3}
          expanded={false}
          label="Executive Director Teams"
          readonly
          targetCount={5}
        />
      </Gutter>
    </View>
    <Spacing size={20}>
      <FlexView>
        <Code>{'canExpand={false}'}</Code>
      </FlexView>
    </Spacing>
    <Spacing size={20}>
      <Heading level={1}>Checkbox</Heading>
      <Spacer size={16} />
      <Text>
        The <Code>{'isChecked'}</Code> prop controls the checked state of the
        checkbox.
      </Text>
    </Spacing>
    <View style={styles.wrapper}>
      <Gutter>
        <PeopleListItem
          hasCheckbox
          peopleList={peopleList}
          currentCount={3}
          isChecked
          label="Executive Director Teams"
          targetCount={5}
        />
      </Gutter>
    </View>
    <Spacing size={20}>
      <FlexView>
        <Code>{'isChecked={true}'}</Code>
      </FlexView>
    </Spacing>
    <Spacing size={20}>
      <Heading level={1}>Readonly</Heading>
      <Spacer size={16} />
      <Text>
        A <Code>{'PeopleListItem'}</Code> with the <Code>{'readonly'}</Code>{' '}
        prop is used for list items that are not clickable.
      </Text>
    </Spacing>
    <View style={styles.wrapper}>
      <Gutter>
        <PeopleListItem
          hasCheckbox
          peopleList={peopleList}
          currentCount={3}
          label="Executive Director Teams"
          readonly
          targetCount={5}
        />
      </Gutter>
    </View>
    <FlexView>
      <Spacing size={20}>
        <Code>{'readonly={true}'}</Code>
      </Spacing>
    </FlexView>
    <Spacing size={20}>
      <Heading level={1}>OneLineLayout</Heading>
      <Spacer size={16} />
      <Text>
        The <Code>{'oneLineLayout'}</Code> prop determines the layout of the
        list item. If true, the list item layout will be on a single line.
      </Text>
    </Spacing>
    <View style={styles.wrapper}>
      <Gutter>
        <PeopleListItem
          hasCheckbox
          peopleList={peopleList}
          currentCount={3}
          label="Executive Director Teams"
          readonly
          targetCount={5}
          oneLineLayout
          canExpand={false}
        />
      </Gutter>
    </View>
    <FlexView>
      <Spacing size={20}>
        <Code>{'oneLineLayout={true}'}</Code>
      </Spacing>
    </FlexView>
    <View style={styles.wrapper}>
      <Gutter>
        <PeopleListItem
          hasCheckbox
          peopleList={peopleList}
          currentCount={3}
          label="Executive Director Teams"
          readonly
          targetCount={5}
          oneLineLayout
          canExpand
          expanded={false}
        />
      </Gutter>
    </View>
    <FlexView>
      <Spacing size={20}>
        <Code>{'oneLineLayout={true}'}</Code>
        <Code>{'canExpand={true}'}</Code>
      </Spacing>
    </FlexView>
  </ScrollView>
));
